import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCard3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 5.83333H14.5M4.09982 9.36191H8.86648M2.36667 3.23334H13.6333C14.112 3.23334 14.5 3.62136 14.5 4.1V11.9C14.5 12.3787 14.112 12.7667 13.6333 12.7667H2.36667C1.88802 12.7667 1.5 12.3787 1.5 11.9V4.1C1.5 3.62136 1.88802 3.23334 2.36667 3.23334Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCard3;
